module.exports = __webpack_public_path__ + "img/icon-facebook.974e5872.svg";